export default class SelectControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.select = document.createElement('select')
    this.select.id = window.PRIM.getUUID()
    this.select.disabled = args.readonly ? 'disabled' : ''
    this.select.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.select.id

    if (args.options) {
      args.options.forEach((optionItem) => {
        let option = document.createElement('option')
        option.innerHTML = optionItem.label
        option.value = optionItem.value
        this.select.appendChild(option)
      })
    }

    this.select.value = args.value ? args.value : ''

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.select)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.select.value ? this.select.value : null
  }

  setValue (value) {
    this.select.value = value ? value : ''
  }
}


// WEBPACK FOOTER //
// ./js/lib/ui/SelectControl.js